module.exports = __webpack_public_path__ + "static/media/PrivacyPolicy_sq.d67dfba7.md";